module.exports = __webpack_public_path__ + "img/horizontal_7_5_8017.1c55fb9f.png";